"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Label_1 = require("../components/Label");
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
exports.Field = function (props) {
    var label = props.label, helpText = props.helpText;
    var classes = __spreadArrays([
        'c-field'
    ], distillUtilityClasses_1.default(props));
    // If there is only 1 child, we can get it's name to use in our for attribute.
    var forAttribute = (props.children && props.children.props) ? props.children.props.id : null;
    var subContent = (props.children && props.children.length) ? react_1.default.createElement("div", { className: "c-field-group" }, props.children) : props.children;
    return react_1.default.createElement("div", { className: classes.join(' ') },
        label && react_1.default.createElement(Label_1.Label, { content: label, htmlFor: forAttribute }),
        helpText && react_1.default.createElement(FieldHelper, null, helpText),
        subContent);
};
var FieldHelper = function (props) {
    var classes = __spreadArrays([
        'c-field__help-text'
    ], distillUtilityClasses_1.default(props));
    return react_1.default.createElement("span", { className: classes.join(' ') }, props.children);
};
exports.Field.Helper = FieldHelper;
var FieldGroupLayout;
(function (FieldGroupLayout) {
    FieldGroupLayout["Inline"] = "+inline";
    FieldGroupLayout["Stacked"] = "+stacked";
})(FieldGroupLayout || (FieldGroupLayout = {}));
var FieldGroup = function (props) {
    var _a;
    var classes = __spreadArrays([
        'c-field-group',
        (_a = props.layout) !== null && _a !== void 0 ? _a : FieldGroupLayout.Stacked
    ], distillUtilityClasses_1.default(props));
    return react_1.default.createElement("div", { className: classes.join(' ') }, props.children);
};
FieldGroup.Layout = FieldGroupLayout;
exports.Field.FieldGroup = FieldGroup;
var InputGroup = function (props) {
    var _a;
    var classes = __spreadArrays([
        'c-input-group',
        (_a = props.layout) !== null && _a !== void 0 ? _a : FieldGroupLayout.Stacked
    ], distillUtilityClasses_1.default(props));
    return react_1.default.createElement("div", { className: classes.join(' ') }, props.children);
};
InputGroup.Layout = FieldGroupLayout;
exports.Field.InputGroup = InputGroup;
var FieldSetLayout;
(function (FieldSetLayout) {
    FieldSetLayout["Inline"] = "+inline";
    FieldSetLayout["Stacked"] = "+stacked";
    FieldSetLayout["Fill"] = "+fill";
})(FieldSetLayout || (FieldSetLayout = {}));
var FieldSet = function (props) {
    var _a;
    var legend = props.legend;
    var layoutOptions = (_a = props.layoutOptions) !== null && _a !== void 0 ? _a : [FieldSetLayout.Fill, FieldSetLayout.Inline];
    var classes = __spreadArrays([
        'c-form'
    ], layoutOptions, distillUtilityClasses_1.default(props));
    return react_1.default.createElement("fieldset", { className: classes.join(' ') },
        legend && react_1.default.createElement("legend", null, legend),
        props.children);
};
FieldSet.Layout = FieldSetLayout;
exports.Field.Set = FieldSet;
//# sourceMappingURL=Field.js.map